import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/personal-information/personal-information.component').then(
        (m) => m.PersonalInformationComponent,
      ),
  },
  {
    path: 'exercise-right',
    loadComponent: () =>
      import('./features/exercise-rights/exercise-rights.component').then(
        (m) => m.ExerciseRightsComponent,
      ),
  },
  {
    path: 'contact-details',
    loadComponent: () =>
      import('./features/contact-details/contact-details.component').then(
        (m) => m.ContactDetailsComponent,
      ),
  },
  {
    path: 'exercise-right-reason',
    loadComponent: () =>
      import('./features/exercise-right-reason/exercise-right-reason.component').then(
        (m) => m.ExerciseRightReasonComponent,
      ),
  },
  {
    path: 'communication-channel',
    loadComponent: () =>
      import('./features/communication-channel/communication-channel.component').then(
        (m) => m.ChoiseCommunicationChannelComponent,
      ),
  },
  {
    path: 'proof-of-identity',
    loadComponent: () =>
      import('./features/proof-of-identity/proof-of-identity.component').then(
        (m) => m.ProofOfIdentityComponent,
      ),
  },
  {
    path: 'summary',
    loadComponent: () =>
      import('./features/summary/summary.component').then((m) => m.SummaryComponent),
  },
  {
    path: 'confirmation',
    loadComponent: () =>
      import('./features/confirmation/confirmation.component').then((m) => m.ConfirmationComponent),
  },
  {
    path: 'error',
    loadComponent: () => import('./features/error/error.component').then((m) => m.ErrorComponent),
  },
];
